import { render, staticRenderFns } from "./table-header-label.vue?vue&type=template&id=7ab22602&scoped=true"
import script from "./table-header-label.vue?vue&type=script&lang=ts"
export * from "./table-header-label.vue?vue&type=script&lang=ts"
import style0 from "./table-header-label.vue?vue&type=style&index=0&id=7ab22602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab22602",
  null
  
)

export default component.exports